import useRollbarUtil from "@/components/hooks/useRollbarUtil";
import { useMeQuery } from "@/generated/graphql";

export const useMe = () => {
  const { getNotifyErrorHandlerForGraphQL } = useRollbarUtil();

  const { loading, data } = useMeQuery({
    onError: getNotifyErrorHandlerForGraphQL("failed to get me (user info)"),
  });

  const me = data?.me;
  const meLoading = loading;

  return {
    me,
    meLoading,
  };
};
